import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "i18n";

import Button from "Common/Button/Button";

export class Controls extends Component {
  componentDidUpdate(prevProps, prevState) {
    const { updated, saveCallback } = this.props;

    if (updated) {
      saveCallback();
    }
  }

  handleCancel() {
    const { closeDiv, closeDivType, onCancel } = this.props;

    if (typeof onCancel === "function") {
      onCancel();
      return;
    }

    const clDiv =
      closeDivType === "id"
        ? document.getElementById(closeDiv)
        : document.getElementsByClassName(closeDiv).item(0);
    clDiv.click();
  }

  handleOk() {
    const { dispatch, action } = this.props;
    dispatch(action());
  }

  renderBtnOK() {
    const {
      updating,
      updated,
      ok,
      action,
      successMessage,
      progressMessage
    } = this.props;
    if (updating) {
      // $(".controls").addClass("saving");
      return (
        <Button className="controls__save">
          {progressMessage ? progressMessage : _("Saving...")}
          {/*<i className="icon icon-refresh" />*/}
        </Button>
      );
    }
    // $(".controls").removeClass("saving");
    if (updated) {
      return (
        <Button onClick={() => this.handleCancel()} className="controls__save">
          {successMessage ? successMessage : _("Successfully updated!")}
          <i className="icon icon-like" />
        </Button>
      );
    }
    return (
      <Button onClick={action} className="controls__save">
        {ok}
      </Button>
    );
  }

  render() {
    const { cancel } = this.props;

    return (
      <div className="settings__controls">
        <Button variant="outline" onClick={this.handleCancel.bind(this)}>
          {cancel}
        </Button>
        {this.renderBtnOK()}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Controls);



// WEBPACK FOOTER //
// ./src/components/Settings/Controls.js